import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider } from "@chakra-ui/react";
import "./index.scss";
import "./tailwind.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import reportWebVitals from "./reportWebVitals";
import { toast } from "react-toastify";
import { store } from "./redux/store";
import { Provider } from "react-redux";

Sentry.init({
    dsn: "https://82354d0ed83a4566577415ab14c810da@o4506713428066304.ingest.us.sentry.io/4506713435930624",
    environment: import.meta.env.VITE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Tracing: https://docs.sentry.io/platforms/javascript/guides/react/tracing/
    tracesSampleRate: (import.meta.env.VITE_ENV === "production" ? 0.2 : 1.0),
    tracePropagationTargets: ["localhost", "intertru.ai", "intertru.com", /^\//],
    // Replays: https://docs.sentry.io/platforms/javascript/guides/react/session-replay/
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <div id="main-container">
      <Provider store={store}>
        <ChakraProvider>
          <App />
        </ChakraProvider>
    </Provider>
  </div>

  // </React.StrictMode>
);
if (import.meta.env.VITE_ENV !== "production") {
  // for development only
  window.addEventListener("error", (e) => toast.error(e.message));
  window.addEventListener("unhandledrejection", (e) =>
    toast.error(e.reason.message)
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();